<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9V4Qhq/tc-custom/9781466804319.jpg?1737166184440" alt="This image is the cover for the book Cleared Hot!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cleared Hot!
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A “vividly told” Vietnam War combat diary shedding light on the Marine Corps pilots who brought soldiers home and went back for more (</b><i><b>Booklist</b></i><b>).</b></p><p>Every day, every mission, he took the war to the enemy’s heart. Only his quick wit and steely nerves could bring him through alive.</p><p>As a Marine pilot in Vietnam, Col. Bob Stoffey led a life that was constantly under siege. Flying SAR—Search and Rescue—helicopter missions at treetop level over enemy-held territory, he quickly learned how to dodge raging storms of enemy fire—and how to fight back with deadly accuracy.</p><p>Volunteering for the most dangerous air missions of the Vietnam conflict, Col. Stoffey later came back for more: taking on a second tour of duty as a forward air controller who directed naval gunfire, artillery, and thunderous air strikes from the cockpit of his OV-10 Bronco. Saving men from certain death, flying at impossibly low levels, Stoffey used his M-60 machine guns and 2.75-inch rockets—and he always shot to kill.</p><p>In this remarkable memoir, Bob Stoffey chronicles his four-year-long war—and brings to life the special exhilaration of flying into heart-stopping danger and coming back alive.<br/><br/><b>Includes eight pages of heroic photographs.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Stoffey
      </h2>
      
      <p class="authorDescription body article"><P><B>Col. Bob Stoffey </B>was born in Coaldale, Pennsylvania, and graduated from Pennsylvania State University. He served as a Marine Corps pilot for twenty-five years, having flown twenty-four different types of aircraft worldwide. His many military decorations include the Marine Corps Medal for Personal Heroism, two Distinguished Flying Crosses, and twenty-five Air Medals. He retired in 1979 and now lives in Carlsbad, California, with his wife.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b71e1f6